<template>
  <AuthView :title="`Email ${id}`">
    <AppRow :split="[5, 7]">
      <div>
        <pre class="mb-6">{{ email }}</pre>
        <v-form :ref="setFormRef" class="flex gap-3">
          <EmailField v-model="to" label="To" />
          <AppBtn
            :loading
            :disabled="!valid"
            prepend-icon="mdi:email-outline"
            @click="send(id, email.template)"
          >
            Resend
          </AppBtn>
        </v-form>
      </div>
      <div>
        <iframe :srcdoc="email.html!" width="100%" height="800" />
      </div>
    </AppRow>
  </AuthView>
</template>

<script setup lang="ts">
import { getSentEmail, resendEmail } from '~/helpers/http';
import type { EmailTemplate } from '~/types';

definePageMeta({ middleware: 'admin' });

const id = useRoute().params.email as string;

const email = await getSentEmail(id);
if (!email) throw new Error('Order not found');

const to = ref(email.to[0]);

const { setFormRef, submit, loading, valid } = useForm();

function send(id: string, template: EmailTemplate) {
  submit(async () => {
    await resendEmail({ id, template, to: to.value });
  }, { successMsg: 'Email resent successfully' });
}
</script>

<style scoped>
pre {
  white-space: pre-wrap;
  word-wrap: break-word;
  overflow: auto;
  max-height: 300px;
}
</style>